export const DESKTOP_PET_SIZE = 104;
export const DESKTOP_PET_RIGHT = 18;
export const DESKTOP_PET_BOTTOM = 16;
export const DESKTOP_PET_COMPOSER_GAP = 16;

export const DESKTOP_PET_FOOTPRINT = DESKTOP_PET_RIGHT + DESKTOP_PET_SIZE + DESKTOP_PET_COMPOSER_GAP;

export function isDesktopPetChatPath(pathname) {
  return /^\/(c|g|m)\//.test(pathname || '');
}

export function isDesktopPetOccupyingComposer({
  pathname,
  isDesktop,
  isMD,
  hasPet,
  isVoiceModeActive,
  isArtifactOpen,
} = {}) {
  return Boolean(
    isDesktopPetChatPath(pathname)
    && isDesktop
    && !isMD
    && hasPet
    && !isVoiceModeActive
    && !isArtifactOpen
  );
}

/**
 * Extra right padding the composer needs so Send / Autto sit left of the
 * floating companion. Returns 0 when the pet is hidden or the current
 * message width already leaves a gutter.
 */
export function getDesktopPetComposerClearance({
  isVisible,
  windowWidth,
  navigationSidebarWidth = 0,
  contextSidebarWidth = 0,
  composerMaxWidth = Number.POSITIVE_INFINITY,
  existingRightPadding = 0,
} = {}) {
  if (!isVisible || !Number.isFinite(windowWidth) || windowWidth <= 0) return 0;

  const nav = Math.max(0, Number(navigationSidebarWidth) || 0);
  const contextRight = Math.max(0, Number(contextSidebarWidth) || 0);
  const chatPaneWidth = Math.max(0, windowWidth - nav - contextRight);
  const pad = Math.max(0, Number(existingRightPadding) || 0);
  const available = Math.max(0, chatPaneWidth - pad * 2);
  const maxWidth = Number.isFinite(composerMaxWidth) ? composerMaxWidth : available;
  const composerWidth = Math.min(Math.max(0, maxWidth), available);
  const sideSpace = (available - composerWidth) / 2;
  const composerRight = nav + pad + sideSpace + composerWidth;
  const petLeft = windowWidth - DESKTOP_PET_RIGHT - DESKTOP_PET_SIZE;

  return Math.max(0, Math.ceil(composerRight - petLeft + DESKTOP_PET_COMPOSER_GAP));
}
